import React from "react";
import Navigation from "./pageComponents/navbar";
import AthletesList from "./pageComponents/renderAthleteRegTable";
import RegistrationForm from "./pageComponents/registrationForm";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import stones from "../assets/stones.png"
import wfd from '../assets/wfd.jpg';
import hammer from '../assets/Hammers.jpg'
import wob from '../assets/wob.png'
import sheaf from '../assets/sheaf.jpg'
import caber from '../assets/cabers.jpg'
import TimerCountdown from "./pageComponents/dateTimer";
import ContactForm from "./pageComponents/contactform";
import Footer from "./pageComponents/footer";

function HighlandGames() {
  return (
    <>
      <Navigation />
      <Container>
        <Row>
          <Col >
            <h1>Introduction to the Highland Games</h1>
            <p>
            Experience the tradition and excitement of the Highland Games, a proud Scottish celebration dating back to the 11th century! These legendary feats of strength have inspired iconic events like the modern shot put. With nine thrilling competitions throughout the day, the top three athletes will earn well-deserved recognition, prizes, and a place in Highland Games history!
            </p>
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={stones} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>Stones of Strength</h2>
          <p>
          The stone throw — often called the "Stone Put" — is one of the oldest and most iconic events in the Highland Games, tracing its roots back nearly a thousand years to medieval Scotland.

          Historically, Scottish clans would test their warriors' strength by having them throw large stones found in rivers or fields. These early challenges were often informal tests of power, used both for entertainment and to select the strongest men for battle or leadership roles.
          </p>
          <p>
          The tradition evolved into two main types of stone throws still seen today:
          </p>
          <ul>
            <li>
              <b>Braemar Stone:</b> A heavier stone (often 20–26 pounds) thrown from a standing position — no run-up allowed. This style reflects ancient contests where movement was restricted for fairness.
            </li>
            <li>
              <b>Open Stone:</b> A lighter stone (16–22 pounds), thrown with a full run-up and glide, much like the Olympic shot put. This style allowed for more technique and athleticism.
            </li>
          </ul>
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>Weights for Distance</h2>
          <p>
            The Weight for Distance throw is one of the core strength events in the Highland Games, with a lineage reaching back centuries into Scottish history.

            Originally, the event grew out of practical feats of strength performed by warriors and laborers. Heavy objects like blacksmith's weights, farm implements, or even large stones fitted with iron rings were thrown to measure a man’s raw strength and power. These contests were informal at first — local gatherings and clan meetings often featured strength challenges as entertainment, social competition, and a way to honor the strongest individuals.
          </p>
          <p>
            As the Highland Games became more formalized in the 19th century, Weight for Distance was codified into two official events:
            </p>
            <ul>
              <li>
                <b>Light Weight for Distance</b>: Typically a 28-pound weight
              </li>
              <li>
                <b>Heavy Weight for Distance</b>: Typically a 56-pound weight
              </li>
            </ul>

          </Col>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={wfd} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={hammer} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>The Hammer Toss</h2>
          <p>
            The Scottish Hammer Throw is one of the oldest and most iconic events of the Highland Games, with deep roots stretching back to medieval Scotland.

            The event is believed to have originated from practical challenges where warriors would throw heavy objects — such as blacksmiths’ sledgehammers, cart axles, or large mallets — to demonstrate strength, stamina, and battle-readiness. Early records suggest that competitions involving the throwing of heavy implements were a central part of clan gatherings and local festivals as early as the 11th and 12th centuries.
          </p>
          <p>
          Unlike the Olympic hammer throw, the Scottish hammer remains true to its traditional form:
          </p>
          <ul>
            <li>
            A heavy metal or wooden ball, usually weighing 16 pounds (light hammer) or 22 pounds (heavy hammer), is attached to a stiff wooden shaft about four feet long.
            </li>
            <li>
            Athletes do not spin inside a circle like in modern track and field. Instead, they stand stationary, often with their feet dug into the ground or behind a wooden "trig," and swing the hammer around their head before launching it over their shoulder for distance.
            </li>
          </ul>
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>Weight Over Bar</h2>
            <p>
            Originally, the challenge grew from informal tests of strength at clan gatherings, fairs, and festivals. Warriors and laborers would compete by hurling heavy objects — stones, weights, or anvils — vertically over a raised rope or wooden bar. These contests showcased not just brute strength but also explosive power and precision, traits highly valued in warriors.
            </p>
            <p>
            Today’s event typically uses a 56-pound weight (four stone) attached to a short handle. Athletes stand beneath a raised crossbar and swing the weight between their legs, then explode upward, throwing the weight up and over the bar using only one hand. After each successful round, the bar is raised higher until only one athlete remains.
            </p>
          </Col>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={wob} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={sheaf} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>The Sheaf Toss</h2>
          <p>
          The Sheaf Toss is one of the most unique and crowd-pleasing events of the Highland Games, blending rural Scottish tradition with feats of strength and skill.

          The event traces its roots back to agricultural life in Scotland and Ireland, where farm laborers would compete by tossing bundles of hay, straw, or grain over a high bar using pitchforks. These informal competitions often broke out during harvest festivals and local fairs, celebrating both the hard work of the farmers and their physical prowess.
          </p>
          <p>
          In today’s Sheaf Toss:
          </p>
          <ul>
            <li>
            Athletes use a two- or three-tined pitchfork to hurl a burlap bag stuffed with straw (the "sheaf") over a crossbar.
            </li>
            <li>
            The sheaf typically weighs 16 or 20 pounds, depending on the competition.
            </li>
            <li>
            Just like Weight Over Bar, the bar is raised after each successful throw, and the athlete who clears the highest height wins.
            </li>
          </ul>
          </Col>
        </Row>
        <Row style={{marginTop: '2rem'}}>
          <Col sm={12} md={6} lg={6} xl={6}>
          <h2>The Caber Toss</h2>
          <p>
          The Caber Toss is the signature event of the Highland Games — a dramatic test of strength, balance, and technique that has become a symbol of Scottish athletic tradition worldwide.

          The word "caber" comes from the Gaelic cabar, meaning "wooden beam" or "pole."
          Historically, the caber toss likely developed from the practical skills needed in the Highlands: flipping large logs to bridge rivers or build structures. Over time, this necessary labor evolved into a competitive display of strength at clan gatherings and festivals.
          </p>
          <p>
          In the modern Caber Toss:
          </p>
          <ul>
            <li>
              The athlete lifts a massive wooden log — typically 16–20 feet long and weighing 90–150 pounds — from the ground into a vertical standing position.
            </li>
            <li>
              With a running start, the competitor must flip the caber so that it turns end-over-end in the air and lands directly away from them in a perfect "12 o'clock" position.
            </li>
            <li>
              Distance does not matter — only the accuracy and form of the toss are judged.
            </li>
            <li>
              A perfect caber toss — where the caber flips and falls straight away at exactly 12 o'clock — is extremely rare and considered a great honor for any athlete!
            </li>
          </ul>

          </Col>
          <Col className="d-flex justify-content-center align-items-center" sm={12} md={6} lg={6} xl={6}>
            <img src={caber} alt="" style={{maxWidth: '20rem', maxHeight: '20rem'}} className="img-fluid w-100 w-md-75 w-lg-50" />
          </Col>
        </Row>
        <Row style={{marginTop: '4rem', marginBottom: '3rem'}}>
          <h2>Now you know about the events. <br/><br/> Wanna give it a go?</h2>
          <Col sm={12} lg={4} xs={12} style={{marginTop: '4rem'}}>
            <RegistrationForm />
          </Col>
          <Col lg={8} sm={12} xs={12} style={{marginTop: '4rem'}}>
            <AthletesList />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center align-items-center">
          <Col>
            <TimerCountdown />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center align-items-center">
          <Col>
            <ContactForm />
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default HighlandGames;
